import { useQuery } from '@tanstack/react-query';
import { checkCoachingReachable } from '../api/checkCoachingReachable';
import { COACHING_REACHABILITY_QUERY_KEY } from '../constants';

// Verifies the Coaching host is reachable every time the view is entered.
// Runs in parallel with the token request; never cached, never auto-retried.
export const useCoachingReachability = ({ enabled = true } = {}) => {
  const query = useQuery({
    queryKey: COACHING_REACHABILITY_QUERY_KEY,
    queryFn: checkCoachingReachable,
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    isReachable: query.data === true,
    isChecking: query.isPending || query.isFetching,
    isUnreachable: query.isError,
  };
};
